// import React, { useState } from 'react';
// import { Table, Spinner, Form, Row, Col, Button, Alert, Badge } from 'react-bootstrap';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import type { APIResponse } from '@store/Shared/shared';
// import { ntxAPI } from '@API/axiosNeatex';
// import { Card, CardBody, CardFooter, CardHeader } from '@components/card/card';

// interface OutstandingPayable {
//   peoplE_ID: string;
//   peoplE_NUMBER: string;
//   peoplE_NAME: string;
//   peoplE_NAME2: string | null;
//   invoicE_NUM: string;
//   invoicE_TYPE: string;
//   invoicE_DATE: string;
//   invoicE_AMOUNT: number;
//   duE_DATE_SCHEDULES: string;
//   amounT_PAYMENTS: number;
//   invoicE_AGING_Days: number | null;
// }

// const OutstandingPayablesReport: React.FC = () => {
//   const [data, setData] = useState<OutstandingPayable[]>([]);
//   const [loading, setLoading] = useState<boolean>(false);
//   const [error, setError] = useState<string | null>(null);

//   // Filter states
//   const [selectedSupplier, setSelectedSupplier] = useState<string>('all');
//   const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([null, null]);
//   const [startDate, endDate] = dateRange;

//   // Function to fetch data with filters
//   const fetchData = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       // Prepare query parameters

//       // API call with filters
//       const { data } = await ntxAPI.get<APIResponse<OutstandingPayable[]>>('Reports/GetOutstandingPayablesReport', {
//         params: { StartDate: startDate, EndDate: endDate }
//       });
//       if (data.succeeded === true) {
//         const processedData = data.data.map(item => ({
//           ...item,
//           invoicE_AGING_Days:
//             item.invoicE_AGING_Days ??
//             Math.floor((new Date().getTime() - new Date(item.duE_DATE_SCHEDULES).getTime()) / (1000 * 60 * 60 * 24))
//         }));

//         setData(processedData);
//       } else {
//         setError(data instanceof Error ? data.message : 'An unknown error occurred');
//       }
//       // Calculate aging days for each invoice
//     } catch (err) {
//       setError(err instanceof Error ? err.message : 'An unknown error occurred');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Get unique suppliers for dropdown
//   const getUniqueSuppliers = () => {
//     const suppliers = data.map(item => ({
//       id: item.peoplE_ID,
//       name: item.peoplE_NAME
//     }));

//     return Array.from(new Map(suppliers.map(item => [item.id, item])).values());
//   };

//   const resetFilters = () => {
//     setSelectedSupplier('all');
//     setDateRange([null, null]);
//   };

//   const formatCurrency = (amount: number): string => {
//     return new Intl.NumberFormat('en-US', {
//       style: 'currency',
//       currency: 'USD'
//     }).format(amount);
//   };

//   const formatDate = (dateString: string): string => {
//     return new Date(dateString).toLocaleDateString();
//   };

//   // Calculate balance amount
//   const calculateBalance = (invoiceAmount: number, paymentsAmount: number) => {
//     return invoiceAmount - paymentsAmount;
//   };

//   // Get aging badge color based on days
//   const getAgingBadgeColor = (days: number | null) => {
//     if (days === null) return 'secondary';
//     if (days <= 0) return 'success';
//     if (days <= 30) return 'info';
//     if (days <= 60) return 'warning';
//     return 'danger';
//   };

//   return (
//     <div className='container mt-4'>
//       <Card>
//         <CardHeader className='d-flex justify-content-between align-items-center'>
//           <h5 className='mb-0'>Outstanding Payables Report</h5>
//           {data.length > 0 && (
//             <div>
//               <span className='me-2'>Showing: {data.length} invoices</span>
//             </div>
//           )}
//         </CardHeader>

//         <CardBody>
//           {error && (
//             <Alert variant='danger' className='mb-4'>
//               Error loading data: {error}
//             </Alert>
//           )}

//           {/* Filters Section */}
//           <Card className='mb-4'>
//             <CardHeader>Filters</CardHeader>
//             <CardBody>
//               <Form>
//                 <Row className='g-3'>
//                   <Col md={4}>
//                     <Form.Group controlId='supplierFilter'>
//                       <Form.Label>Supplier</Form.Label>
//                       <Form.Select value={selectedSupplier} onChange={e => setSelectedSupplier(e.target.value)}>
//                         <option value='all'>All Suppliers</option>
//                         {getUniqueSuppliers().map((supplier, index) => (
//                           <option key={` {supplier.id}- {index}`} value={supplier.id}>
//                             {supplier.name}
//                           </option>
//                         ))}
//                       </Form.Select>
//                     </Form.Group>
//                   </Col>

//                   <Col md={4}>
//                     <Form.Group controlId='dateRangeFilter'>
//                       <Form.Label>Due Date Range</Form.Label>
//                       <DatePicker
//                         selectsRange={true}
//                         startDate={startDate}
//                         endDate={endDate}
//                         onChange={update => setDateRange(update)}
//                         isClearable={true}
//                         className='form-control'
//                         placeholderText='Select date range'
//                       />
//                     </Form.Group>
//                   </Col>

//                   <Col xs={12} className='text-end'>
//                     <Button variant='secondary' onClick={resetFilters} className='me-2'>
//                       Reset Filters
//                     </Button>
//                     <Button variant='primary' onClick={fetchData} disabled={loading}>
//                       {loading ? (
//                         <>
//                           <Spinner
//                             as='span'
//                             animation='border'
//                             size='sm'
//                             role='status'
//                             aria-hidden='true'
//                             className='me-2'
//                           />
//                           Loading...
//                         </>
//                       ) : (
//                         'Load Report'
//                       )}
//                     </Button>
//                   </Col>
//                 </Row>
//               </Form>
//             </CardBody>
//           </Card>

//           {/* Results Section */}
//           {loading ? (
//             <div className='text-center my-5'>
//               <Spinner animation='border' role='status'>
//                 <span className='visually-hidden'>Loading...</span>
//               </Spinner>
//               <p className='mt-2'>Loading outstanding payables data...</p>
//             </div>
//           ) : data.length > 0 ? (
//             <div className='table-responsive'>
//               <Table striped bordered hover>
//                 <thead>
//                   <tr>
//                     <th>Supplier</th>
//                     <th>Invoice #</th>
//                     <th>Type</th>
//                     <th>Invoice Date</th>
//                     <th>Due Date</th>
//                     <th>Invoice Amount</th>
//                     <th>Paid Amount</th>
//                     <th>Balance</th>
//                     <th>Aging Days</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {data.map((item, index) => {
//                     const balance = calculateBalance(item.invoicE_AMOUNT, item.amounT_PAYMENTS);
//                     return (
//                       <tr key={` {item.peoplE_ID}- {item.invoicE_NUM}- {index}`}>
//                         <td>
//                           <div>{item.peoplE_NAME}</div>
//                           {item.peoplE_NAME2 && <div className='text-muted small'>{item.peoplE_NAME2}</div>}
//                         </td>
//                         <td>{item.invoicE_NUM}</td>
//                         <td>{item.invoicE_TYPE}</td>
//                         <td>{formatDate(item.invoicE_DATE)}</td>
//                         <td>{formatDate(item.duE_DATE_SCHEDULES)}</td>
//                         <td>{formatCurrency(item.invoicE_AMOUNT)}</td>
//                         <td>{formatCurrency(item.amounT_PAYMENTS)}</td>
//                         <td className={balance > 0 ? 'text-danger' : 'text-success'}>{formatCurrency(balance)}</td>
//                         <td>
//                           <Badge bg={getAgingBadgeColor(item.invoicE_AGING_Days)}>
//                             {item.invoicE_AGING_Days !== null ? ` {item.invoicE_AGING_Days} days` : 'N/A'}
//                           </Badge>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </Table>
//             </div>
//           ) : (
//             <div className='text-center py-5'>
//               <p>No data available. Set your filters and click "Load Report" to generate.</p>
//             </div>
//           )}
//         </CardBody>

//         {data.length > 0 && (
//           <CardFooter className='text-muted'>Report generated on {new Date().toLocaleString()}</CardFooter>
//         )}
//       </Card>
//     </div>
//   );
// };

// export default OutstandingPayablesReport;

import React, { useState } from 'react';
import { Table, Spinner, Form, Row, Col, Button, Alert, Badge } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import type { APIResponse } from '@store/Shared/shared';
import { ntxAPI } from '@API/axiosNeatex';
import { Card, CardBody, CardFooter, CardHeader } from '@components/card/card';

interface OutstandingPayable {
  peoplE_ID: string;
  peoplE_NUMBER: string;
  peoplE_NAME: string;
  peoplE_NAME2: string | null;
  invoicE_NUM: string;
  invoicE_TYPE: string;
  invoicE_DATE: string;
  invoicE_AMOUNT: number;
  duE_DATE_SCHEDULES: string;
  amounT_PAYMENTS: number;
  invoicE_AGING_Days: number | null;
}

const OutstandingPayablesReport: React.FC = () => {
  const [data, setData] = useState<OutstandingPayable[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  // Filter states
  const [selectedSupplier, setSelectedSupplier] = useState<string>('all');
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([null, null]);
  const [startDate, endDate] = dateRange;

  // Function to fetch data with filters
  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await ntxAPI.get<APIResponse<OutstandingPayable[]>>('Reports/GetOutstandingPayablesReport', {
        params: { StartDate: startDate, EndDate: endDate }
      });

      if (data.succeeded === true) {
        const processedData = data.data.map(item => ({
          ...item,
          invoicE_AGING_Days:
            item.invoicE_AGING_Days ??
            Math.floor((new Date().getTime() - new Date(item.duE_DATE_SCHEDULES).getTime()) / (1000 * 60 * 60 * 24))
        }));

        setData(processedData);
      } else {
        setError(data instanceof Error ? data.message : 'حدث خطأ غير معروف');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'حدث خطأ غير معروف');
    } finally {
      setLoading(false);
    }
  };

  // Get unique suppliers for dropdown (من البيانات الحالية)
  const getUniqueSuppliers = () => {
    const suppliers = data.map(item => ({
      id: item.peoplE_ID,
      name: item.peoplE_NAME
    }));

    return Array.from(new Map(suppliers.map(item => [item.id, item])).values());
  };

  const resetFilters = () => {
    setSelectedSupplier('all');
    setDateRange([null, null]);
  };

  const formatCurrency = (amount: number): string => {
    return new Intl.NumberFormat('en-US').format(amount);
  };

  const formatDate = (dateString: string): string => {
    return new Date(dateString).toLocaleDateString('en-US');
  };

  // Calculate balance amount
  const calculateBalance = (invoiceAmount: number, paymentsAmount: number) => {
    return invoiceAmount - paymentsAmount;
  };

  // Get aging badge color based on days
  const getAgingBadgeColor = (days: number | null) => {
    if (days === null) return 'secondary';
    if (days <= 0) return 'success';
    if (days <= 30) return 'info';
    if (days <= 60) return 'warning';
    return 'danger';
  };

  const agingLabel = (days: number | null) => {
    if (days === null) return 'غير متاح';
    return `${days} يوم`;
  };

  return (
    <div className=' '>
      <Card className='border-0'>
        <CardBody>
          {error && (
            <Alert variant='danger' className='mb-4'>
              خطأ في تحميل البيانات: {error}
            </Alert>
          )}

          {/* Filters Section */}
          <Card className='mb-4'>
            <CardHeader className='d-flex justify-content-between align-items-center'>
              <div className='mb-0'>الفلاتر</div>
              {data.length > 0 && (
                <div>
                  <span className='me-2'>الإجمالي: {data.length} فاتورة</span>
                </div>
              )}
            </CardHeader>

            <CardBody>
              <Form>
                <Row className='g-3'>
                  <Col md={4}>
                    <Form.Group controlId='supplierFilter'>
                      <Form.Label>المورد</Form.Label>
                      <Form.Select value={selectedSupplier} onChange={e => setSelectedSupplier(e.target.value)}>
                        <option value='all'>كل الموردين</option>
                        {getUniqueSuppliers().map((supplier, index) => (
                          <option key={`${supplier.id}-${index}`} value={supplier.id}>
                            {supplier.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group controlId='dateRangeFilter'>
                      <Form.Label>فترة تاريخ الاستحقاق</Form.Label>
                      <DatePicker
                        selectsRange={true}
                        startDate={startDate}
                        endDate={endDate}
                        onChange={update => setDateRange(update)}
                        isClearable={true}
                        className='form-control text-center'
                        placeholderText='اختر الفترة'
                      />
                    </Form.Group>
                  </Col>

                  <Col xs={12} className='text-end'>
                    <Button variant='secondary' onClick={resetFilters} className='me-2'>
                      تصفير الفلاتر
                    </Button>

                    <Button variant='primary' onClick={fetchData} disabled={loading}>
                      {loading ? (
                        <>
                          <Spinner
                            as='span'
                            animation='border'
                            size='sm'
                            role='status'
                            aria-hidden='true'
                            className='me-2'
                          />
                          جاري التحميل...
                        </>
                      ) : (
                        'تحميل التقرير'
                      )}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>

          {/* Results Section */}
          {loading ? (
            <div className='text-center my-5'>
              <Spinner animation='border' role='status'>
                <span className='visually-hidden'>جاري التحميل...</span>
              </Spinner>
              <p className='mt-2'>جاري تحميل بيانات الذمم الدائنة...</p>
            </div>
          ) : data.length > 0 ? (
            <div className='table-responsive'>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>المورد</th>
                    <th>رقم الفاتورة</th>
                    <th>النوع</th>
                    <th>تاريخ الفاتورة</th>
                    <th>تاريخ الاستحقاق</th>
                    <th>قيمة الفاتورة</th>
                    <th>المبلغ المدفوع</th>
                    <th>الرصيد</th>
                    <th>أيام التأخر</th>
                  </tr>
                </thead>

                <tbody>
                  {data.map((item, index) => {
                    const balance = calculateBalance(item.invoicE_AMOUNT, item.amounT_PAYMENTS);
                    return (
                      <tr key={`${item.peoplE_ID}-${item.invoicE_NUM}-${index}`}>
                        <td>
                          <div>{item.peoplE_NAME2}</div>
                          {/* {item.peoplE_NAME2 && <div className='text-muted small'>{item.peoplE_NAME2}</div>} */}
                        </td>

                        <td>{item.invoicE_NUM}</td>
                        <td>{item.invoicE_TYPE}</td>
                        <td>{formatDate(item.invoicE_DATE)}</td>
                        <td>{formatDate(item.duE_DATE_SCHEDULES)}</td>
                        <td>{formatCurrency(item.invoicE_AMOUNT)}</td>
                        <td>{formatCurrency(item.amounT_PAYMENTS)}</td>

                        <td className={balance > 0 ? 'text-danger' : 'text-success'}>{formatCurrency(balance)}</td>

                        <td>
                          <Badge bg={getAgingBadgeColor(item.invoicE_AGING_Days)}>{agingLabel(item.invoicE_AGING_Days)}</Badge>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          ) : (
            <div className='text-center py-5'>
              <p>لا توجد بيانات. اختر الفلاتر ثم اضغط "تحميل التقرير" لعرض التقرير.</p>
            </div>
          )}
        </CardBody>

        {data.length > 0 && (
          <CardFooter className='text-muted'>تم إنشاء التقرير بتاريخ {new Date().toLocaleString('en-US')}</CardFooter>
        )}
      </Card>
    </div>
  );
};

export default OutstandingPayablesReport;